<template>
  <Modal :hideExit="false" cClass="w-200 bg-white" @cancel="close">
    <template #header>
      <p class="typo-heading20 typo-medium text-light-high">{{ $t("pricing.canNotMakeDefault") }}</p>
    </template>
    <template #default>
      <span v-if="!isTrial" class="upgrade-plan_content">
        {{ $t("pricing.canNotMakeDefaultContent", { value: pageTypeDisplay }) }}

        <strong> ({{ totalPublished }}/{{ limitNumberPagePublish }}). </strong>
      </span>
      <span v-else-if="isTrial && !isExpired" class="upgrade-plan_content">
        {{ $t("pricing.canNotMakeDefaultTrialContent") }}
        <strong> ({{ totalPublished }}/{{ limitNumberPagePublish }}). </strong>
      </span>
      <span v-else-if="isTrial && isExpired" class="upgrade-plan_content">
        {{ $t("limitation.trialExpiredMakeDefault", { value: pageTypeDisplay }) }}
      </span>
    </template>
    <template #footer>
      <div class="btn-group flex-row-reverse make-default-btn">
        <button class="btn btn-primary ml-2" @click="process">{{ $t("pricing.updatePlan") }}</button>
        <button class="btn btn-outline" @click="close">{{ $t("generals.cancel") }}</button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import { PLAN_NO } from "@/contants/plan";
import { PAGE_TYPE } from "@/contants/page";

export default {
  name: "ModalUpgradePlan",
  props: {
    pageType: String
  },
  computed: {
    ...mapState({
      publishedPagesCountStore: state => state.page.publishedPageCount || 0,
      publishedPagesCountStoreByTypes: state => state.page.publishedPage
    }),
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    pageTypeDisplay() {
      if (!this.checkPublishedAllPage) {
        return "page";
      }
      if (this.pageType === PAGE_TYPE.COLLECTION_PAGE) {
        return "Collection page";
      } else if (this.pageType === PAGE_TYPE.PRODUCT_PAGE) {
        return "Product page";
      } else if (this.pageType === PAGE_TYPE.LANDING_PAGE) {
        return "Landing page";
      } else if (this.pageType === PAGE_TYPE.BLOG_PAGE) {
        return "Article page";
      }

      return "Home page";
    },

    remainingDays() {
      return this.shopInfo?.remainingDays !== undefined && this.shopInfo?.remainingDays !== null ? this.shopInfo?.remainingDays : 30;
    },

    isTrial() {
      return this.shopInfo.plan === PLAN_NO.TRIAL2022 || this.shopInfo?.plan === PLAN_NO.TRIAL;
    },
    isExpired() {
      return this.remainingDays <= 0;
    },

    checkPublishedAllPage() {
      const planLimitation = this.shopInfo?.developmentStore ? this.shopInfo?.planLimitation[this.shopInfo?.planDevelopmentStore] : this.shopInfo?.planLimitation[this.shopInfo?.plan];
      if (planLimitation) {
        return this.publishedPagesCount < planLimitation?.pagePublish?.nbOfPublishedPage;
      }
      return true;
    },

    limitNumberPagePublish() {
      const planLimitation = this.shopInfo?.developmentStore ? this.shopInfo?.planLimitation[this.shopInfo?.planDevelopmentStore] : this.shopInfo?.planLimitation[this.shopInfo?.plan];
      if (planLimitation) {
        if (!this.checkPublishedAllPage) {
          return planLimitation?.pagePublish?.nbOfPublishedPage;
        }
        if (this.pageType === PAGE_TYPE.PRODUCT_PAGE) {
          return planLimitation?.pagePublish?.nbOfPublishedProductPage || 0;
        } else if (this.pageType === PAGE_TYPE.BLOG_PAGE) {
          return planLimitation?.pagePublish?.nbOfPublishedArticlePage || 0;
        }
        return planLimitation?.pagePublish?.nbOfPublishedPage;
      }
      return 0;
    },

    publishedPagesCount() {
      return (this.shopInfo?.publishedPagesCount || 0) + this.publishedPagesCountStore;
    },

    totalPublished() {
      if (!this.checkPublishedAllPage) {
        return this.publishedPagesCount;
      }
      if (this.pageType === PAGE_TYPE.PRODUCT_PAGE) {
        return this.shopInfo.publishedProductPagesCount + (this.publishedPagesCountStore[this.pageType] || 0);
      } else if (this.pageType === PAGE_TYPE.BLOG_PAGE) {
        return this.shopInfo.publishedArticlePagesCount + (this.publishedPagesCountStore[this.pageType] || 0);
      }
      return this.publishedPagesCount;
    },

    pageLimitNumber() {
      if (this.shopInfo.plan === PLAN_NO.TRIAL2022) {
        return 1;
      }

      if (this.pageType === PAGE_TYPE.PRODUCT_PAGE && this.shopInfo.plan === PLAN_NO.BUILD && this.shopInfo.publishedProductPagesCount >= 10) {
        return 10;
      }

      return 0;
    }
  },
  methods: {
    close() {
      this.$emit("closeModalUpgradePlan");
    },
    process() {
      this.$router.push({
        name: "Pricing",
        query: {
          from: "make_default"
        }
      });
    }
  }
};
</script>

<style scoped>
.upgrade-plan_content {
  color: #676767;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
}
</style>
